import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';

var AddonsThemeFlat =
/** @class */
function (_super) {
  __extends(AddonsThemeFlat, _super);

  function AddonsThemeFlat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return AddonsThemeFlat;
}(
/** @class */
function () {
  function class_1() {}

  return class_1;
}());

export { AddonsThemeFlat };
export var AddonsThemeFlatInternal = exposeGetters(AddonsThemeFlat);